// app/shared/providers/RealtimeNotificationsProvider.tsx (Example)
'use client';
import React from 'react';


export function RealtimeNotificationsProvider({ children }: { children: React.ReactNode }) {
  // 🔥 TEMPORARY: Disable realtime completely to fix crashes - will re-enable after webhook transition
  // useRealtimePucNotifications(); // Initialize the hook
  console.log('[RealtimeNotificationsProvider] Realtime temporarily disabled to fix crashes');
  return <>{children}</>;
}